import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  vendorProfile: [],
  error: null,
  loader: false,
}

export const vendorProfileSlice = createSlice({
  name: 'vendorProfile',
  initialState: initialState,
  reducers: {
    setVendorProfile: (state, { payload }) => {
      state.vendorProfile = payload?.data ?? payload;
    },
    setVendorProfiles: (state, { payload }) => {
      state.vendorProfile = payload?.data;
    },
    removeVendorProfile: (state, { payload }) => {
      state.error = payload
    },
    clearAllVendorProfile: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})


export const fetchVendorProfile = (data) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
  
      const json = await Api.fetchVendorProfile(data)
      if (json.status >= 200 && json.status < 300) {
        dispatch(setVendorProfiles(json.data))
        // callback(true, json.data.message)
        dispatch(setLoader(false))
      } else if (json.status == 422) {
        dispatch(setError(json.data))
        // callback(false, json.data.message)
        dispatch(setLoader(false))
      }else{
        dispatch(setLoader(false))
      }
    } catch (error) {
      console.log(error)
      dispatch(setLoader(false))
      // callback(false)
    }
  }
  
export const updateVendorProfile = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateVendorProfile(data)
    if (json.status >= 200 && json.status < 300) {
      // dispatch(setType(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}


// export const changePassword = (data, callback) => async (dispatch) => {
//     const apiService = new Api();
//     dispatch(setError({}))
//     dispatch(setLoader(true))
//     try {
  
//       const json = await Api.changePassword(data)
//       if (json.status >= 200 && json.status < 300) {
//         callback(true, json.data.message)
//       } else if (json.status == 422) {
//         dispatch(setError(json.data))
//         callback(false, json.data.message)
//       }
//     } catch (error) {
//       console.log(error)
//       // callback(false)
  
//     }
//     dispatch(setLoader(false))
//   }


export const { setVendorProfile, setVendorProfiles, clearAllVendorProfile, setLoader, setError, setMoreVendorProfiles } = vendorProfileSlice.actions


export default vendorProfileSlice.reducer
export const vendorProfileSelector = state => state.vendorProfile


